const scrollLeftMax = (element) => element.scrollLeftMax || (element.scrollWidth - element.clientWidth);
const scrollTopMax = (element) => element.scrollTopMax || (element.scrollWidth - element.clientWidth);

export {
    scrollLeftMax,
    scrollTopMax
}




// WEBPACK FOOTER //
// ./assets/vue/utils/scroll-helper.js